// extracted by mini-css-extract-plugin
module.exports = {"collectionListItem":"ListItem_collectionListItem__33NTO","editItem":"ListItem_editItem__3gdt5","deleteItem":"ListItem_deleteItem__3ni7w"};